/*
 * @Author: your name
 * @Date: 2021-05-20 09:21:12
 * @LastEditTime: 2022-11-14 10:08:46
 * @LastEditors: zhangzhian@linshimuye.com
 * @Description: 岗位激励的路由配置
 * @FilePath: \dhr_frontend\src\routes\modules\postIncentive.js
 */
export default [
  {
    name: "roster",
    path: "/postIncentive/roster",
    component: () => import("@/views/postIncentive/roster/Index.vue"),
    meta: {
      title: "岗位激励花名册",
    },
  },
  {
    name: "bondRecord",
    path: "/postIncentive/bondRecord",
    component: () => import("@/views/postIncentive/bondRecord/bondRecord.vue"),
    meta: {
      title: "保证金记录",
    },
  },
  {
    name: "postAllocation",
    path: "/postIncentive/postAllocation",
    component: () => import("@/views/postIncentive/postAllocation/index.vue"),
    meta: {
      title: "岗位激励岗位配置",
    },
  },
  {
    name: "recordIndex",
    path: "/postIncentive/recordIndex",
    component: () =>
      import("@/views/postIncentive/changeRecord/recordIndex.vue"),
    meta: {
      title: "岗位激励变动记录",
    },
  },
  {
    name: "assessmentActivities",
    path: "/postIncentive/assessmentActivities",
    component: () =>
      import("@/views/postIncentive/assessmentActivities/index.vue"),
    meta: {
      title: "测评活动",
    },
  },
  {
    name: "assessmentActivitiesGroup",
    path: "/postIncentive/assessmentActivities/detail/activitiesGroup",
    component: () =>
      import("@/views/postIncentive/assessmentActivities/activitiesGroup.vue"),
    meta: {
      parentAuth: "/postIncentive/assessmentActivities",
      title: "活动分组",
    },
  },
  {
    name: "assessmentActivitiesView",
    path: "/postIncentive/assessmentActivities/view",
    component: () =>
      import("@/views/postIncentive/assessmentActivities/activitiesView.vue"),
    meta: {
      parentAuth: "/postIncentive/assessmentActivities",
      title: "活动审批查看",
    },
  },
  {
    name: "assessmentActivitiesGroupView",
    path: "/postIncentive/assessmentActivitiesGroup/view",
    component: () =>
      import("@/views/postIncentive/assessmentActivities/activitiesView.vue"),
    meta: {
      parentAuth: "/postIncentive/assessmentActivities",
      title: "活动分组审批查看",
    },
  },
  {
    name: "dividendImport",
    path: "/postIncentive/dividendImport",
    component: () => import("@/views/postIncentive/dividendImport/index.vue"),
    meta: {
      title: "导入分红",
    },
  },

  {
    name: "postIncentiveAccounting",
    path: "/postIncentive/accounting",
    component: () => import("@/views/postIncentive/accounting/index.vue"),
    meta: {
      title: "岗位激励核算",
    },
  },

  {
    name: "postMonthShouldPayImport",
    path: "/postIncentive/postMonthShouldPayImport",
    component: () => import("@/views/postIncentive/dividendImport/shouldPayIndex.vue"),
    meta: {
      title: "导入应发",
    },
  },
];
